<template>
  <v-dialog v-model="opened" max-width="800" persistent>
    <v-form
      ref="form"
      v-model="valid"
      :readonly="!canEdit"
      @submit.prevent="save()"
    >
      <v-card :loading="loadingData" :disabled="loadingData">
        <v-card-title class="headline">
          {{ !id ? " Tambah" : "Ubah" }} Transfer Personal Trainer
          <v-btn icon @click="close()" class="ml-auto">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row justify="center" no-gutters>
              <v-col cols="12" md="10">
                <v-row dense>
                  <v-col cols="12" md="12">
                    <v-select
                      label="Tipe Transfer"
                      dense
                      outlined
                      v-model="data.transfer_personal_trainer_type"
                      :items="listTransferPersonalTrainerType"
                      item-text="name"
                      item-value="id"
                      clearable
                      :rules="[rules.transfer_personal_trainer_type]"
                    />

                    <!-- Dari Personal Trainer -->
                    <v-autocomplete
                      label="Dari Personal Trainer"
                      dense
                      outlined
                      v-model="data.from_personal_trainer_id"
                      :items="listPersonalTrainers"
                      item-text="name"
                      item-value="id"
                      :rules="[rules.from_personal_trainer_id]"
                      :readonly="isEdit"
                      :clearable="!isEdit"
                      :menu-props="{ disabled: isEdit }"
                      :append-outer-icon="isEdit ? 'mdi-lock' : undefined"
                    />

                    <!-- Paket Member yang akan ditransfer -->
                    <v-autocomplete
                      label="Paket Member yang akan ditransfer"
                      dense
                      outlined
                      v-model="data.sales_item_id"
                      :items="listSalesItems"
                      item-text="name"
                      item-value="id"
                      :rules="[rules.sales_item_id]"
                      :readonly="isEdit"
                      :clearable="!isEdit"
                      :menu-props="{ disabled: isEdit }"
                      :append-outer-icon="isEdit ? 'mdi-lock' : undefined"
                    />

                    <!-- Ke Personal Trainer -->
                    <v-autocomplete
                      label="Ke Personal Trainer"
                      dense
                      outlined
                      v-model="data.to_personal_trainer_id"
                      :items="listPersonalTrainers"
                      item-text="name"
                      item-value="id"
                      :rules="[rules.to_personal_trainer_id]"
                      :readonly="isEdit"
                      :clearable="!isEdit"
                      :menu-props="{ disabled: isEdit }"
                      :append-outer-icon="isEdit ? 'mdi-lock' : undefined"
                    />

                    <v-textarea
                      label="Keterangan"
                      dense
                      outlined
                      v-model="data.description"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row no-gutters>
            <v-col cols="12" align="end">
              <v-btn depressed class="ma-1" :disabled="loading" @click="close()">
                <v-icon small left>mdi-close</v-icon>
                Tutup
              </v-btn>
              <v-btn
                v-if="canEdit"
                type="submit"
                color="success"
                depressed
                class="ma-1"
                :loading="loading"
                :disabled="loading"
                @click.prevent="save()"
              >
                <v-icon small left>mdi-content-save</v-icon>
                Simpan
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { slugify } from "@/core/utils";
import UploadAdapter from "../../../../core/plugins/UploadAdapter";

export default {
  async mounted() {
    const personalTrainers = await ApiService.get("user/list?role_slug=personal-trainer");
    this.listPersonalTrainers = personalTrainers.data;
  },
  data() {
    return {
      action: "create",
      id: null, // UUID saat edit
      opened: false,
      loading: false,
      loadingData: false,
      valid: true,

      listPersonalTrainers: [],
      listSalesItems: [],

      listTransferPersonalTrainerType: [
        { id: "resign", name: "Resign" },
        { id: "terminate", name: "Terminate" },
        { id: "request", name: "Request" },
      ],

      data: {
        transfer_personal_trainer_type: null,
        from_personal_trainer_id: null,
        to_personal_trainer_id: null,
        transfer_personal_trainer_date: null,
        description: null,
        sales_item_id: null,
      },

      rules: {
        transfer_personal_trainer_type: (v) =>
          (v !== null && v !== undefined && v !== "") || "Tipe harus dipilih",
        from_personal_trainer_id: (v) =>
          (v !== null && v !== undefined && v !== "") || "Dari PT harus dipilih",
        to_personal_trainer_id: (v) =>
          (v !== null && v !== undefined && v !== "") || "Ke PT harus dipilih",
        sales_item_id: (v) =>
          (v !== null && v !== undefined && v !== "") || "Paket harus dipilih",
        transfer_personal_trainer_date: (v) =>
          (v !== null && v !== undefined && v !== "") ||
          "Tanggal transfer harus diisi",
      },
    };
  },
  props: {
    module: { type: String },
    success: { type: Function, default: function () {} },
  },
  methods: {
    open(id) {
      this.opened = true;
      setTimeout(() => {
        this.$refs.form.reset();
        if (id) {
          this.getData(id);
        }
      }, 1);
    },

    async getData(id) {
      this.loadingData = true;
      this.id = id;
      try {
        const { data } = await ApiService.get("transfer-personal-trainer?id=" + id);

        // Isi data awal (tahan from_personal_trainer_id agar watcher tidak men-trigger fetch duluan)
        this.data = {
          slug: data.slug,
          sales_item_id: data.sales_item_id,
          description: data.description,
          from_personal_trainer_id: null, // set belakangan
          to_personal_trainer_id: data.to_personal_trainer_id,
          transfer_personal_trainer_type: data.transfer_personal_trainer_type,
          transfer_personal_trainer_date: data.transfer_personal_trainer_date || null,
        };

        // Saat EDIT: ambil SEMUA item berdasarkan PT (non-active)
        await this.fetchListSalesItemByPt(data.from_personal_trainer_id);

        // Pastikan item yang dipilih ada di list (fallback kalau API tidak mengembalikan)
        const found = this.listSalesItems.find((item) => item.id === data.sales_item_id);
        if (!found && data.sales_item?.package && data.sales_item?.member) {
          this.listSalesItems.push({
            id: data.sales_item.id,
            name: `${data.sales_item.member.name} | Package: ${data.sales_item.package.name} | Expired Date: ${data.sales_item.expired_date}`,
          });
        }

        // Set nilai after fetching list
        this.data.from_personal_trainer_id = data.from_personal_trainer_id;

        // Paksa re-render sales_item_id bila perlu
        this.$nextTick(() => {
          this.data.sales_item_id = data.sales_item_id;
        });
      } catch (err) {
        if (err.response?.data) {
          this.handleError(err.response.data);
        }
      } finally {
        this.loadingData = false;
      }
    },

    async save() {
      this.$refs.form.validate();
      if (this.valid) {
        this.loading = true;
        const action = !this.id ? "post" : "update";
        let url = "transfer-personal-trainer";
        if (this.id) url = url + "?id=" + this.id;

        ApiService[action](url, this.data)
          .then(({ data }) => {
            if (data.id) {
              this.loading = false;
              this.success(data);
              this.$swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil disimpan",
                showConfirmButton: false,
                timer: 3000,
              });
              this.close();
            }
          })
          .catch(({ response }) => {
            if (response?.data) this.handleError(response.data);
            this.loading = false;
          });
      }
    },

    handleError(data) {
      if (data?.error) {
        this.$swal.fire({
          icon: "warning",
          title: "Terjadi kesalahan",
          text: data.error,
          showConfirmButton: true,
          timer: 5000,
        });
      }
    },

    close() {
      this.opened = false;
      this.data = {};
      this.id = null;
      this.$refs.form.reset();
      this.success();
    },

    uploader(editor) {
      editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
        return new UploadAdapter(loader, "file");
      };
    },

    // CREATE: hanya item aktif berdasarkan PT
    async fetchListSalesItemActive(personalTrainerId) {
      this.loadingData = true;
      try {
        const response = await ApiService.get(
          `sales/list-item-active-by-pt?personal_trainer_id=${personalTrainerId}`
        );
        const dataSales = response.data || [];
        this.listSalesItems = dataSales.map((item) => ({
          id: item.id,
          name: `${item.member.name} | Package: ${item.package.name} | Expired Date: ${item.expired_date}`,
        }));
      } catch (error) {
        this.handleError(error.response?.data || { error: "Gagal memuat paket aktif" });
      } finally {
        this.loadingData = false;
      }
    },

    // EDIT: semua item berdasarkan PT (termasuk non-active/expired)
    async fetchListSalesItemByPt(personalTrainerId) {
      this.loadingData = true;
      try {
        const response = await ApiService.get(
          `sales/list-item-by-pt?personal_trainer_id=${personalTrainerId}`
        );
        const dataSales = response.data || [];
        this.listSalesItems = dataSales.map((item) => ({
          id: item.id,
          name: `${item.member.name} | Package: ${item.package.name} | Expired Date: ${item.expired_date}`,
        }));
      } catch (error) {
        this.handleError(error.response?.data || { error: "Gagal memuat paket (non-active)" });
      } finally {
        this.loadingData = false;
      }
    },
  },

  watch: {
    ["data.name"](value) {
      this.data.slug = value ? slugify(value) : null;
    },
    // Dinamis: create vs edit untuk sumber paket
    ["data.from_personal_trainer_id"](ptId) {
      if (ptId) {
        if (this.isEdit) {
          this.fetchListSalesItemByPt(ptId);       // EDIT → semua
        } else {
          this.fetchListSalesItemActive(ptId);     // CREATE → yang aktif saja
        }
      } else {
        this.listSalesItems = [];
      }
    },
  },

  computed: {
    isEdit() {
      return Boolean(this.id); // aman untuk UUID string
    },
    canEdit() {
      if (this.id && !this.$store.getters.hasPermission(this.module, "update")) {
        return false;
      }
      return true;
    },
    canVerification() {
      return this.$store.getters.hasPermission(this.module, "verification");
    },
  },
};
</script>
